<template>
    <div
        role="alert"
        class="p-4 mb-8 text-on-accent rounded-md text-center"
        :class="type === 'success' ? 'bg-green-900' : 'bg-red-900'"
    >
        {{ message }}
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            default: '',
        },
        // 'error' | 'success'
        type: {
            type: String,
            default: 'error',
        },
    },
};
</script>
